import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Container, Typography, Breadcrumbs, Link, Box, Divider, CircularProgress } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

// Import API service
import * as industryApi from '../services/industry';

// Import Components
import ValueChainTable from '../components/valueChain/ValueChainTable';

const ValueChainPage = () => {
  const { type, id } = useParams(); // "type" can be "industry" or "subIndustry"
  const navigate = useNavigate();
  const [industry, setIndustry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIndustry = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch industry with value chain data
        const data = await industryApi.getIndustryById(id, {
          includeValueChain: true
        });

        if (data) {
          setIndustry(data);
        } else {
          setError('Industry not found');
        }
      } catch (err) {
        console.error('Error fetching industry:', err);
        setError('Failed to load industry data');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchIndustry();
    }
  }, [id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !industry) {
    return (
      <Box p={4}>
        <Typography color="error">{error || 'Industry not found'}</Typography>
      </Box>
    );
  }

  return (
    <Container maxWidth="xl">
      {/* Breadcrumbs for Navigation */}
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{ mb: 3 }}>
        <Link color="inherit" href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
          Home
        </Link>
        <Link color="inherit" href={`/industry/${industry.id}`} onClick={(e) => { e.preventDefault(); navigate(`/industry/${industry.id}`); }}>
          {industry.name}
        </Link>
        <Typography color="text.primary">Value Chain</Typography>
      </Breadcrumbs>

      {/* Page Title */}
      <Typography variant="h3" gutterBottom>{industry.name} Value Chain</Typography>
      <Typography variant="subtitle1" color="text.secondary">
        Explore the structured value chain model for {industry.name}.
      </Typography>
      <Divider sx={{ my: 3 }} />

      {/* Value Chain Table Component */}
      <ValueChainTable
        valueChainId={id}
        valueChainData={industry.valueChainStages ? {
          stages: industry.valueChainStages.sort((a, b) => a.order - b.order)
        } : null}
      />
    </Container>
  );
};

export default ValueChainPage;
